import { createLocalStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/local-storage/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';

const localStorageProvider = createLocalStorageProvider('', false);

// Helper functions to get the checkbox value in sprint edit component from local storage
export const EDIT_SPRINT_CHECKBOX_CACHE_KEY = 'edit_sprint_cache_value';

export const getCheckboxValueFromLocalStorage = (key: string): boolean => {
	let value;
	if (fg('jfp-vulcan-browser-storage-migration')) {
		value = localStorageProvider.get(key);
	} else if (typeof window !== 'undefined') {
		value = window.localStorage?.getItem(key);
	}
	return value ? JSON.parse(value) : true;
};

export const setCheckBoxValueInLocalStorage = (key: string, value: boolean): void => {
	try {
		if (fg('jfp-vulcan-browser-storage-migration')) {
			localStorageProvider.set(key, value);
		} else if (typeof window !== 'undefined') {
			// @ts-expect-error - TS2345 - Argument of type 'boolean' is not assignable to parameter of type 'string'.
			window.localStorage.setItem(key, value);
		}
	} catch {
		// do nothing
	}
};
